import React from "react";

import CircularProgress from "@mui/material/CircularProgress";
import ContainerForClinic from "./ContainerForClinic";

import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  selectClinicHasMore,
  selectClinicList,
  selectLoading,
  selectSortConfig,
} from "store/ClinicStore/selectors";
import {
  loadMoreClinics,
  changeSortOfClinicList,
} from "store/ClinicStore/actions";
import { StatusENUM } from "../../../types/common";

const ClinicListContainer: React.FC<{
  disableClinic: (clinicId: string, status: StatusENUM) => void;
  editClinic: (clinicId: string) => void;
  addClinicAdmin: (clinicId: string) => void;
}> = ({ disableClinic, editClinic, addClinicAdmin }) => {
  const dispatch = useAppDispatch();
  const clinicList = useAppSelector(selectClinicList);
  const hasMoreItems = useAppSelector(selectClinicHasMore);
  const sortConfig = useAppSelector(selectSortConfig);
  const isLoading = useAppSelector(selectLoading);

  const onClick = (sortBy: string) => {
    dispatch(changeSortOfClinicList(sortBy));
  };

  const onLoadMore = React.useCallback(() => {
    dispatch(loadMoreClinics());
  }, [dispatch]);

  return isLoading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        marginTop: "40px",
      }}
    >
      <CircularProgress color="inherit" size={50} />
    </div>
  ) : (
    <div className="mt-6 flex flex-col white-space-nowrap pb-16">
      <ContainerForClinic
        clinicList={clinicList}
        onClick={onClick}
        sortConfig={sortConfig}
        loading={isLoading}
        onLoadMore={onLoadMore}
        hasMoreItems={hasMoreItems}
        editClinic={editClinic}
        disableClinic={disableClinic}
        addClinicAdmin={addClinicAdmin}
      />
    </div>
  );
};

export default ClinicListContainer;
